module.exports = __webpack_public_path__ + "img/PK_Asset_Info_Web5.fa13b7bf.png";